import { Card } from 'components/ui'
import React, { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

function HeroSection() {
    const [showImage, setShowImage] = useState(false)
    const { t } = useTranslation()

    useEffect(() => {
        // Set showImage to true after a delay (you can adjust the delay as needed)
        const delay = 1000 // 1 second
        const timer = setTimeout(() => {
            setShowImage(true)
        }, delay)

        return () => {
            clearTimeout(timer)
        }
    }, [])

    return (
        <Fragment>
            <Card
                className="!w-full !h-screen !relative !bg-cover !bg-fixed !bg-no-repeat mb-20"
                style={{
                    backgroundImage: `url("${t(
                        'home:content.hero.images.backgroundImage'
                    )}")`,
                }}
            >
                <div className="absolute top-0 left-0 right-0 rounded-[6px]  w-[100%] h-[100%] bg-gradient-to-r from-pink-400 to-yellow-400 opacity-90 transition-all duration-300 "></div>
                <div className="flex flex-col justify-center items-center gap-10 w-[100%] h-[100%] lg:flex-row xl:flex-row 2xl:flex-row absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
                    <div
                        className={`bg-[url('https://www.getmyslice.com/wp-content/uploads/2022/03/GMS_App-Demo_HomeScreen_MothersDayMGP.png')] bg-cover bg-no-repeat w-[260px] h-[500px] transition-transform duration-1000 ease-in ${
                            showImage ? 'translate-x-0' : 'translate-x-[-800px]'
                        }`}
                    ></div>
                    <div className="">
                        <h1>{t('home:content.hero.h1')}</h1>
                        <h4
                            dangerouslySetInnerHTML={{
                                __html: t('home:content.hero.h4'),
                            }}
                        />
                    </div>
                </div>
            </Card>
        </Fragment>
    )
}

HeroSection.propTypes = {
    // add propTypes here
}

export default HeroSection
